<template>
  <div class="px-4 pb-4 sm:px-6 sm:pb-6">
    <h1 class="my-2">{{ t("headings.create_bulletin") }}</h1>
    <breadcrumb class="mt-3 mb-4" />
    <div v-if="formElements" class="card grid p-4">
      <custom-form
        :formElements="formElements"
        formStyle="inline"
        @submitForm="createBulletin"
      />
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import Breadcrumb from "../components/breadcrumb/Breadcrumb.vue";
import CustomForm from "../components/form/CustomForm.vue";

export default {
  components: { Breadcrumb, CustomForm },
  setup() {
    const store = useStore();
    const { t } = useI18n();

    const company = computed(() => store.state.company.company);
    const estates = computed(() => store.state.estate.estates);
    const roles = computed(() => store.state.role.roles);
    const user = computed(() => store.state.authentication.user);

    const waiting = computed(() => {
      if (store.state.company.waiting) return true;
      if (store.state.estate.waiting) return true;
      if (store.state.role.waiting) return true;
      if (store.state.authentication.waiting) return true;
      return false;
    });

    const formElements = ref(null);

    const setFormElements = () => {
      formElements.value = [
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "input",
          id: "topic",
          label: "topic",
          rules: ["isRequired"],
          type: "text",
          value: "",
          variable: "topic",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "textarea",
          id: "content",
          label: "content",
          rows: 5,
          rules: ["isRequired"],
          value: "",
          variable: "content",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "filepicker",
          accept: "application/pdf",
          disabled: false,
          id: "file",
          label: "files",
          multiple: true,
          rules: [],
          showFilename: true,
          textVariant: company.value.primaryText,
          value: [],
          variable: "files",
          variant: company.value.primary,
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "multiselect",
          id: "estates",
          label: "estates",
          optionLabel: ["name"],
          options: estates.value,
          rules: ["isRequired"],
          value: [],
          variable: "estateIds",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "multiselect",
          id: "groups",
          label: "groups",
          optionLabel: ["label"],
          options: roles.value.filter(
            (role) => !role.label.includes("partner") && role.label != "admin"
          ),
          rules: ["isRequired"],
          translatableLabel: "roles",
          value: [],
          variable: "roleIds",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "checkbox",
          id: "publish",
          label: "publish",
          invalid: false,
          rules: [],
          value: false,
          variable: "publish",
          variant: company.value.primary,
        },
        {
          class: "col-span-12 text-right",
          element: "button",
          id: "submit-button",
          label: "save",
          textVariant: company.value.primaryText,
          type: "submit",
          variant: company.value.primary,
        },
      ];
    };

    const createBulletin = (formData) => {
      const data = {
        companyId: user.value.companyId,
        content: formData.content,
        estateIds: formData.estateIds,
        files: formData.files,
        publish: formData.publish,
        roleIds: formData.roleIds,
        topic: formData.topic,
        // channels: formData.channels
      };
      store.dispatch("bulletin/createBulletin", data);
    };

    onMounted(() => {
      if (!estates.value.length) {
        store.dispatch("estate/getEstates", user.value.companyId);
      }
      if (!roles.value.length) {
        store.dispatch("role/getRoles");
      }
      if (company.value.id && estates.value.length && roles.value.length) {
        setFormElements();
      }
    });

    watch(
      () => waiting.value,
      (waiting) => {
        if (!waiting) {
          setFormElements();
        }
      }
    );

    return {
      createBulletin,
      formElements,
      t,
    };
  },
};
</script>
